import React from 'react';
const ServiceItem = ({value: {title,text}}) => {
    return (
        <div className="service__content">
            <div>
                <i className="uil uil-icons service__icon"></i>
                <h3 className="service__title">{title}</h3>
                <span className="service_description">{text}</span>
            </div>
            <span className="button button__flex button__small button__link service__button">
                View More
                <i className="uil uil-arrow-right button__icon"></i>
            </span>
        </div>
    )
}

export default ServiceItem;